export default "__VITE_ASSET__16ed2316__"